import labels from './blog-category-labels.json';
import type { MarketingLocale } from './localeRoutes';

type CategoryLabelMap = Record<string, Partial<Record<MarketingLocale, string>>>;

const BLOG_CATEGORY_LABELS = labels as CategoryLabelMap;

export function resolveBlogCategoryLabel(
  slug: string | undefined,
  locale: MarketingLocale,
  fallback?: string | null
): string {
  if (!slug) return fallback?.trim() || '';
  const row = BLOG_CATEGORY_LABELS[slug];
  const localized = row?.[locale] || row?.fr;
  if (localized) return localized;
  return fallback?.trim() || slug;
}

export function blogCategoryDocumentTitle(categoryName: string): string {
  return `${categoryName} | Rintintin Pro`;
}
